import classNames from "classnames";
import { Button } from "../buttons/button";

export const EmptyState = ({
  text = "Nothing to see here",
  subtext = "",
  subtextClassName = "",
  textClassName = "",
  imageClassName = "h-[120px] w-[120px]",
  className = "py-12 px-3 gap-4",
  ctaText = "",
  ctaClassName = "",
  onCTAClick = () => {},
  ctaIcon = "",
  image = "/assets/images/calendar.png",
}: {
  text?: string;
  subtext?: string;
  subtextClassName?: string;
  textClassName?: string;
  imageClassName?: string;
  className?: string;
  ctaText?: string;
  ctaClassName?: string;
  onCTAClick?: () => void;
  ctaIcon?: string;
  image?: string;
}) => {
  return (
    <div
      className={classNames(
        "flex w-full flex-col items-center justify-center gap-4 rounded-2xl bg-white px-3 py-12 text-center",
        className,
      )}
    >
      <div
        className={classNames("overflow-hidden object-contain", imageClassName)}
      >
        <img
          alt="calendar"
          src={image}
          className="h-full w-full object-contain"
        />
      </div>

      <p
        className={classNames(
          "text-32 max-w-[320px] font-fraunces font-medium capitalize",
          textClassName,
        )}
      >
        {text}
      </p>

      <p
        className={classNames(
          "max-w-[320px] text-base text-grey-600",
          subtextClassName,
        )}
      >
        {subtext}
      </p>

      {ctaText ? (
        <Button
          type="button"
          onClick={onCTAClick}
          variation="primary"
          text={ctaText}
          icon={ctaIcon}
          className={`max-w-[272px] ${ctaClassName}`}
        />
      ) : undefined}
    </div>
  );
};
